// @flow
import { getDistance as olGetDistance } from 'ol/sphere';
import Point from 'ol/geom/Point';
import type { Config, SessionConfig, Target } from '../types';
import { fromLatLon, reverseCoordinates } from './index';

export const createGeometry = (target: Target, rotation: number) => {
    const point = new Point(fromLatLon(target.MovementData.Position));
    point.set('rotation', rotation);
    return point;
};

export const getDataSource = (target: Target) => ( (target.DataSource && target.DataSource === 'DEVICE') ? 'device' : 'system' );

export const isActive = (lastUpdate: ?string, sessionConfig: $PropertyType<Config, 'session'>) => {
    const now = Date.now();
    const activityDuration = typeof lastUpdate !== 'undefined' && now - new Date(lastUpdate);
    return typeof activityDuration !== 'undefined' && activityDuration < sessionConfig.disconnected;
};

export const getActivityIndex = (date?: string, sessionConfig: SessionConfig, now?) => {
    if(date) {
        const _now = typeof now !== 'undefined' ? now : Date.now();
        const duration = _now - new Date(date);

        if(duration < sessionConfig.active) {
            return 3;
        }
        else if(duration < sessionConfig.medium) {
            return 2;
        }
        else if(duration < sessionConfig.low) {
            return 1;
        }
        else {
            return 0;
        }
    }
    else {
        return 0;
    }
};

export const getDistance = (p1, p2) => {
    return olGetDistance(reverseCoordinates(p1), reverseCoordinates(p2));
};